import {
  SENTIDOS,
  TRAZAS,
  ACTUACION_REPARACION_FIRMES_ESTRUCTURAS,
  UNIDADES
} from './selectOptions'
import TYPES from '../../../../core/assets/assetTypes'
import comunIdentificacionFormFields from './comunIdentificacionFormFields'
import comunValidacionFormFields from './comunValidacionFormFields'

export const identificacion = (workOrderFragment, familyFragment) => [
  ...comunIdentificacionFormFields(
    workOrderFragment,
    'reparacionesFirmesEstructuras',
    familyFragment,
    [
      TYPES.VPP,
      TYPES.POP,
      TYPES.MUROS,
      TYPES.FIRMES,
      TYPES.PORTICOS,
      TYPES.BANDEROLAS
    ]
  ),

  {
    label: 'Comentarios',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'identificacion',
      'comentarios'
    ]
  }
]

export const inspeccion = (workOrderFragment, familyFragment) => [
  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'inspeccion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'inspeccion',
      'observaciones'
    ]
  }
]

export const ejecucion = (workOrderFragment, familyFragment) => [
  {
    label: 'PK Inicio',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'pkInicio'
    ]
  },

  {
    label: 'PK Fin',
    type: 'PK',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'pkFin'
    ]
  },

  {
    label: 'Sentido',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'sentido'
    ],
    meta: {
      options: SENTIDOS
    }
  },

  {
    label: 'Traza',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'traza'
    ],
    meta: {
      options: TRAZAS
    }
  },

  {
    label: 'Actuación',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'actuacion'
    ],
    meta: {
      options: ACTUACION_REPARACION_FIRMES_ESTRUCTURAS
    }
  },

  {
    label: 'Medición',
    type: 'Number',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'medicion'
    ]
  },

  {
    label: 'Unidad',
    type: 'SimpleSelect',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'unidad'
    ],
    meta: {
      options: UNIDADES
    }
  },

  {
    label: 'Trabajos programados',
    type: 'Checkbox',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'trabajosProgramados'
    ]
  },

  {
    label: 'Observaciones',
    type: 'String',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'observaciones'
    ]
  },

  {
    label: 'Fotos antes',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'antesFotos'
    ],
    meta: { isPhotos: true }
  },

  {
    label: 'Fotos despues',
    type: 'Documents',
    path: [
      'parteTrabajos',
      workOrderFragment,
      'reparacionesFirmesEstructuras',
      familyFragment,
      'ejecucion',
      'despuesFotos'
    ],
    meta: { isPhotos: true }
  }
]

export const validacion = comunValidacionFormFields(
  'reparacionesFirmesEstructuras'
)
